export default __webpack_public_path__ + "static/media/016-upset.3cea196c.svg";